import React, { useState, useContext, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope, faUnlockAlt } from "@fortawesome/free-solid-svg-icons";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Form from "react-bootstrap/Form";
import Container from "react-bootstrap/Container";
import InputGroup from "react-bootstrap/InputGroup";
import Alert from "react-bootstrap/Alert";
import Button from "react-bootstrap/Button";
import FormCheck from "react-bootstrap/FormCheck";
import { Link, useLocation, useNavigate } from 'react-router-dom';

import { AppRoutes } from "../../../routes";
import {lastSolutionsRequest, loginRequest} from "../../../utils/request/api";

import UserContext from "../../../utils/context/user/userContext";
import ServerError from "../ServerError/ServerError";
import {langMap} from "./i18n";
import LanguageContext from "../../../utils/context/i18n/languageContext";
import { errorMessages } from "../../../config/errors";
import { currentYear } from "../../dashboard/config/dates";

import LightcastLogo from "../../../assets/img/Lighcast_RGB_Lockup_Color_full.png"
import AnalystImage from "../../../assets/img/analyst-page-image.png"
import PeopleImage from "../../../assets/img/people_and_students.png"
import BackgroundImage from "../../../assets/img/pink-purple-glow-edited.png"
import { Image, Nav, Spinner } from "react-bootstrap";
import LoadingScreen from "../../../components/LoadingScreen/LoadingScreen";

const Signin = () => {


  const navigate = useNavigate();
  const lang = useContext(LanguageContext).lang;
  const userContext = useContext(UserContext);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [rememberMe, setRememberMe] = useState(true);
  const [unavailable, setUnavailable] = useState(false);
  const [loadingImages, setLoadingImages] = useState(true);
  const [loadingAccess, setLoadingAccess] = useState(false);
  const location = useLocation();

  const handleSubmit = async e => {
    e.preventDefault();
    setLoadingAccess(true);

    const data = await loginRequest(username, password, setUnavailable, rememberMe);
    data.error = data.error ? errorMessages[data.error].EN : "";

    if(data){
      await userContext.handleUserLogin(data);
      
      let logins;
      
      const cleanPathname = location.pathname.replace(/\/$/, '');
      if(cleanPathname !== AppRoutes.Signin.path){
        navigate(cleanPathname);
        setLoadingAccess(false);
      }else if(data.user?.id && data.user?.lastProfile){
        logins = await lastSolutionsRequest(data.user?.id, data.user?.lastProfile);
        if(logins.res?.data.length && logins.res?.data[0].solutionType !== "LEAD_GENERATION"){
          navigate(AppRoutes.Dashboards_template.path + logins.res.data[0].solutionCode)
          setLoadingAccess(false);
        }else{
          navigate(AppRoutes.DashboardOverview.path);
          setLoadingAccess(false);
        }
      }else{
        navigate(AppRoutes.DashboardOverview.path);
        setLoadingAccess(false);
      }
    };
  };

  

  useEffect(() => {
    let loadedCount = 0;

    const backgroundImages = [
      LightcastLogo,
      AnalystImage,
      PeopleImage,
      BackgroundImage
    ]

    backgroundImages.forEach((url) => {
      const img = new window.Image();
      img.src = url;
      img.onload = () => {
        loadedCount++;
        if (loadedCount === backgroundImages.length) {
          setLoadingImages(false);
        }
      };
      img.onerror = () => {
        loadedCount++;
        if (loadedCount === backgroundImages.length) {
          setLoadingImages(false);
        }
      };
    });
  }, []);


  const onErrorDismiss = () => {
    const data =  {
      user: null,
      error: ""
    }
    userContext.handleUserLogin(data);
  }

  if (unavailable){
    return <ServerError onBackToHome={setUnavailable}/>
  }else{
    return (
        <main className="sign-in__page" style={{backgroundImage: `url(${BackgroundImage})`}}>
          {
            loadingImages &&
              <LoadingScreen />
          }
          <section className="d-flex align-items-center sign-in__form__container">
            {/* <Container> */}
              {/* <p className="text-center">
                <Card.Link as={Link} to={AppRoutes.Presentation.path} className="text-gray-lc-600">
                  <FontAwesomeIcon icon={faAngleLeft} className="me-2" /> {langMap.backButton[lang]}
                </Card.Link>
              </p> */}
              {/* <Row className="justify-content-center form-bg-image"> */}
                {/* <Col xs={12} className="d-flex align-items-center justify-content-center"> */}
                  <div className="sign-in__background__left" style={{backgroundImage: `url(${AnalystImage})`}}></div>
                  <div className="border sign-in__form">
                    <Image className="mb-4" src={LightcastLogo} height={40} />
                    <h3 className="text-center fw-bolder text-secondary-lc">Global Solutions Workbench</h3>
                    <p className="text-center text-muted fw-light text-dark-lc  mb-5">Dashboards for LMI analytics</p>
                    {/* <div className="text-center text-md-center mb-4 mt-md-0">
                      <h3 className="mb-0 text-secondary-lc">{langMap.topText[lang]}</h3>
                    </div> */}
                    <Form className="mt-4" onSubmit={handleSubmit}>
                      <Form.Group id="email" className="mb-4">
                        <Form.Label className="text-dark-lc">{langMap.usernameLabel[lang]}</Form.Label>
                        <InputGroup>
                          <InputGroup.Text>
                            <FontAwesomeIcon icon={faEnvelope} className="text-secondary-lc" />
                          </InputGroup.Text>
                          <Form.Control autoFocus required placeholder="example@company.com" onChange={({ target }) => setUsername(target.value)}/>
                        </InputGroup>
                      </Form.Group>
                      <Form.Group>
                        <Form.Group id="pswd" className="mb-4">
                          <Form.Label className="text-dark-lc">{langMap.passwordLabel[lang]}</Form.Label>
                          <InputGroup>
                            <InputGroup.Text>
                              <FontAwesomeIcon icon={faUnlockAlt} className="text-secondary-lc"/>
                            </InputGroup.Text>
                            <Form.Control required autoComplete="pswd" type="password" placeholder="Password" onChange={({ target }) => setPassword(target.value)} />
                          </InputGroup>
                        </Form.Group>
                        {
                          userContext.error &&
                          <div className="d-flex justify-content-between align-items-center mb-4">
                            <Alert variant="danger" dismissible={true} onClose={() => onErrorDismiss()}>
                                {userContext.error}
                            </Alert>
                          </div>
                        }
                        <div className="d-flex justify-content-between align-items-center mb-4">
                          <Form.Check type="checkbox" >
                            <FormCheck.Input id="defaultCheck5" defaultChecked={true} className="me-2" onClick={() => setRememberMe(prev => !prev)} />
                            <FormCheck.Label htmlFor="defaultCheck5" className="mb-0 text-dark-lc">{langMap.rememberButton[lang]}</FormCheck.Label>
                          </Form.Check>
                          {/* <Card.Link className="small text-end">{langMap.lostPswdButton[lang]}</Card.Link> */}
                        </div>
                      </Form.Group>
                      <Button disabled={loadingAccess} variant="secondary-lc" type="submit" className="w-100 sign-in__login-button">
                        {
                          loadingAccess ? 
                          <Spinner animation="border" size="sm" className="me-2 mt-1" /> 
                          : 
                          langMap.signInButton[lang]
                        }
                      </Button>
                      <div className="w-100">
                        <Button variant="primary-lc" as={Link} to={AppRoutes.ForgotPassword.path} className="button-forgot-password w-50 mt-3">
                          Forgot Password?
                        </Button>
                      </div>
                    </Form>
                  </div>
                  <div className="sign-in__background__right"  style={{backgroundImage: `url(${PeopleImage})`}}></div>
                {/* </Col> */}
              {/* </Row> */}
            {/* </Container> */}
          </section>
          <footer className="w-100 footer p-3 bg-dark-lc text-white-lc single-tabledpage">
            <Container>
              <Row>
                <Col>
                  <div className="d-flex text-center justify-content-center align-items-center" id="footer-info" role="contentinfo">
                    <p className="font-weight-normal font-small mb-0">Copyright © Lightcast 2021-<span className="current-year">{ currentYear }</span>. All rights reserved.</p>
                  </div>
                </Col>
              </Row>
              <hr/>
              <Row>
                <Col>
                  <div className="d-flex text-center justify-content-center align-items-center" id="footer-link" role="contentinfo">
                    <Nav className="justify-content-center" activeKey="/home">
                      <Nav.Item>
                        <Nav.Link className="p-5 py-1" href="https://lightcast.io" target="_blank">About</Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link className="p-5 py-1" href="https://lightcast.io/contact" target="_blank">Contact</Nav.Link>
                      </Nav.Item>
                    </Nav>
                  </div>
                </Col>
              </Row>
            </Container>
          </footer>
        </main>
    );
  }
};

export default Signin;